module.exports = __webpack_public_path__ + "img/alarm.8f43e17c.png";